"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var preact_1 = require("preact");
var api = __importStar(require("./api"));
var ab_testing_1 = require("./common/ab-testing");
var cta_1 = __importDefault(require("./embed/cta"));
var sticky_1 = __importDefault(require("./embed/sticky"));
var image_picker_1 = __importDefault(require("./embed/image-picker"));
var tracking_1 = require("./common/tracking");
var session_params_1 = require("./common/session-params");
var landing_1 = require("./generator/landing");
var signals_1 = require("@preact/signals");
var session_1 = require("./common/session");
var countryPromise = fetch("".concat(api.BASE_URL, "/api/country"))
    .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error('Failed')); })
    .then(function (_a) {
    var country = _a.country;
    return country || 'de';
});
var language = location.pathname.split("/")[1] || 'en';
var loading = (0, signals_1.signal)(false);
var photoSelected = function (country, docType, file) { return __awaiter(void 0, void 0, void 0, function () {
    var generatorPath, _a, uploadUrl, uuid, landingCountry, previewInputData, newParams, newUrl, err_1, newUrl;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                generatorPath = 'generatorPath' in window ? window.generatorPath : 'free-biometric-photo-generator';
                loading.value = true;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 6, 7, 8]);
                (0, tracking_1.trackEvent)('embedded_requested');
                return [4 /*yield*/, fetch("".concat(api.BASE_URL, "/api/upload_url"), {
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify(__assign({}, (0, session_params_1.getSessionParams)()))
                    }).then(function (res) { return res.ok ? res : Promise.reject(new Error('File not found')); }).then(function (res) { return res.json(); })];
            case 2:
                _a = _b.sent(), uploadUrl = _a.url, uuid = _a.uuid;
                return [4 /*yield*/, fetch(uploadUrl, {
                        method: 'PUT',
                        body: file
                    })];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, landing_1.getLandingCountry)()];
            case 4:
                landingCountry = _b.sent();
                previewInputData = {
                    country: country,
                    landingCountry: landingCountry,
                    doc: docType,
                    file_uuid: uuid,
                    source: "native_embedded",
                    sessionId: (0, session_1.getSessionId)(),
                };
                return [4 /*yield*/, fetch("".concat(api.BASE_URL, "/api/preview"), {
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify(previewInputData)
                    }).then(function (res) { return res.json(); })];
            case 5:
                _b.sent();
                newParams = new URLSearchParams(location.search);
                newParams.set("file_uuid", uuid);
                newParams.set("country", country);
                newParams.set("doc", docType);
                newUrl = "/".concat(language).concat(generatorPath, "?").concat(newParams.toString());
                location.href = newUrl;
                return [3 /*break*/, 8];
            case 6:
                err_1 = _b.sent();
                newUrl = "/".concat(language).concat(generatorPath);
                location.href = newUrl;
                return [3 /*break*/, 8];
            case 7:
                loading.value = false;
                return [7 /*endfinally*/];
            case 8: return [2 /*return*/];
        }
    });
}); };
var stickyPhotoSelected = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var country, docType;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, countryPromise];
            case 1:
                country = _a.sent();
                docType = 'id-card';
                return [2 /*return*/, photoSelected(country, docType, file)];
        }
    });
}); };
document.querySelectorAll('[data-photo-generator]').forEach(function (node) { return __awaiter(void 0, void 0, void 0, function () {
    var country, docType, styled, cta;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                country = node.getAttribute('data-country');
                if (!!country) return [3 /*break*/, 2];
                return [4 /*yield*/, countryPromise];
            case 1:
                country = _a.sent();
                _a.label = 2;
            case 2:
                docType = node.getAttribute('data-doc') || 'id-card';
                styled = node.getAttribute('data-styled') !== 'false';
                cta = node.getAttribute('data-photo-generator');
                (0, preact_1.render)((0, jsx_runtime_1.jsx)(cta_1.default, { onChange: photoSelected, country: country, docType: docType, language: language, cta: cta, styled: styled, loading: loading }), node);
                return [2 /*return*/];
        }
    });
}); });
document.querySelectorAll('[data-image-picker]').forEach(function (node) { return __awaiter(void 0, void 0, void 0, function () {
    var country, docType, styled, cta;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                country = node.getAttribute('data-country');
                if (!!country) return [3 /*break*/, 2];
                return [4 /*yield*/, countryPromise];
            case 1:
                country = _a.sent();
                _a.label = 2;
            case 2:
                docType = node.getAttribute('data-doc') || 'id-card';
                styled = node.getAttribute('data-styled') !== 'false';
                cta = node.getAttribute('data-photo-generator');
                (0, preact_1.render)((0, jsx_runtime_1.jsx)(image_picker_1.default, { onChange: photoSelected, country: country, docType: docType, language: language, cta: cta, styled: styled, loading: loading }), node);
                return [2 /*return*/];
        }
    });
}); });
var stickyNode = document.createElement('div');
document.body.appendChild(stickyNode);
(0, preact_1.render)((0, jsx_runtime_1.jsx)(sticky_1.default, { onChange: stickyPhotoSelected, loading: loading }), stickyNode);
(0, ab_testing_1.cleanUpTests)();
